import { SubProductAction } from "features/product/types/actions.subproduct";
import { ModalName } from "features/product/types/modals";
import { useDispatch, useSelector } from "services/redux/rootReducer";
import FileUploadModal from "./fileUploadModal";
import NameEditModal from "./nameEditModal";
import PromotionTagUploadModal from "./promotionTagUploadModal";
import SubProductEditModal from "./subProductEditModal";

const ModalManager: React.FC = () => {
    const { modalIds, modals } = useSelector((state) => state.subProducts);

    const dispatch = useDispatch();

    const displayedModals = modalIds.map((modalId) => {
        const params = (modals[modalId] as any)?.params;

        let ShownModalComponent: any;

        switch (modalId) {
            case ModalName.FileUploadModal:
                ShownModalComponent = FileUploadModal;
                break;
            case ModalName.PromotionTagUploadModal:
                ShownModalComponent = PromotionTagUploadModal;
                break;
            case ModalName.NameEditModal:
                ShownModalComponent = NameEditModal;
                break;
            case ModalName.SubProductModal:
                ShownModalComponent = SubProductEditModal;
                break;
            default:
                throw new Error(
                    `Modal component for ${modalId} not added to ModalManager`
                );
        }
        return (
            <ShownModalComponent
                key={modalId}
                onCloseHandler={() => {
                    dispatch({
                        type: SubProductAction.CLOSE_MODAL,
                        id: modalId,
                    });
                }}
                {...params}
            />
        );
    });

    return <>{displayedModals}</>;
};

export default ModalManager;
